import ValidationList from './index.vue'
import ValidationListItem from './item.vue'

export default {
  ValidationList,
  ValidationListItem
}
